import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { FuzzyDate, FuzzyDatesService } from '@hs/ui-core-date';
import { catchError, Observable, of } from 'rxjs';

export const fuzzyDatesResolver: ResolveFn<FuzzyDate[]> = (route): Observable<FuzzyDate[]> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(FuzzyDatesService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    return service.loadFuzzyDates(clientCode)
        .pipe(catchError((error) => {
            errorCollector.addError(`Failed to load fuzzy dates for client ${clientCode}`, error);
            return of([]);
        }));
};
